/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pendingUsersControllerCreate } from '../fn/pending-users/pending-users-controller-create';
import { PendingUsersControllerCreate$Params } from '../fn/pending-users/pending-users-controller-create';
import { pendingUsersControllerFilter } from '../fn/pending-users/pending-users-controller-filter';
import { PendingUsersControllerFilter$Params } from '../fn/pending-users/pending-users-controller-filter';
import { pendingUsersControllerHandlePreSignup } from '../fn/pending-users/pending-users-controller-handle-pre-signup';
import { PendingUsersControllerHandlePreSignup$Params } from '../fn/pending-users/pending-users-controller-handle-pre-signup';
import { ResponsePendingUserDto } from '../models/response-pending-user-dto';

@Injectable({ providedIn: 'root' })
export class PendingUsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pendingUsersControllerCreate()` */
  static readonly PendingUsersControllerCreatePath = '/thalea-cognito-presignup/pending-users';

  /**
   * Create a pending user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pendingUsersControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pendingUsersControllerCreate$Response(params: PendingUsersControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pendingUsersControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a pending user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pendingUsersControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pendingUsersControllerCreate(params: PendingUsersControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.pendingUsersControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pendingUsersControllerHandlePreSignup()` */
  static readonly PendingUsersControllerHandlePreSignupPath = '/thalea-cognito-presignup/pending-users/pre-signup';

  /**
   * Handle Cognito pre-signup trigger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pendingUsersControllerHandlePreSignup()` instead.
   *
   * This method doesn't expect any request body.
   */
  pendingUsersControllerHandlePreSignup$Response(params?: PendingUsersControllerHandlePreSignup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pendingUsersControllerHandlePreSignup(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle Cognito pre-signup trigger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pendingUsersControllerHandlePreSignup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pendingUsersControllerHandlePreSignup(params?: PendingUsersControllerHandlePreSignup$Params, context?: HttpContext): Observable<void> {
    return this.pendingUsersControllerHandlePreSignup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pendingUsersControllerFilter()` */
  static readonly PendingUsersControllerFilterPath = '/thalea-cognito-presignup/pending-users/filter';

  /**
   * Filter pending users by tenant and status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pendingUsersControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pendingUsersControllerFilter$Response(params: PendingUsersControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePendingUserDto>>> {
    return pendingUsersControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter pending users by tenant and status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pendingUsersControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pendingUsersControllerFilter(params: PendingUsersControllerFilter$Params, context?: HttpContext): Observable<Array<ResponsePendingUserDto>> {
    return this.pendingUsersControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePendingUserDto>>): Array<ResponsePendingUserDto> => r.body)
    );
  }

}
